import DOCOnlineBody from "./DOCOnlineBody";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AnonymusDocOnlineService } from "../../services/AnonymusDocOnlineService";
import Spinner from "../../components/Spinner/Spinner";
import DOCOnlineError from "./DOCOnlineError";
import DOCOnlineProvider from "./DOCOnlineContext";
import DocOnlineNavbar from "../../containers/DocOnlineNavbar/DocOnlineNavbar";
import DocOnlineFooter from "../../containers/DocOnlineFooter/DocOnlineFooter";

const DOCOnlinePage = (props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [candidacyCompany, setCandidacyCompany] = useState("");
  const [companyId, setCompanyId] = useState();
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  
  useEffect(() => (document.title = t("AtVitae - DOC Online")), [t]);
  
  useEffect(() => {
    AnonymusDocOnlineService.getDocOnlineByToken(props.match.params.token)
      .then((data) => {
        setCandidacyCompany(data.companyAbbreviation);
        setCompanyId(data.companyId);
        setPrivacyPolicy(data.privacyPolicy);

      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [props.match.params.token]);

  if (isLoading) {
    return <Spinner />;
  }

  if (!!error) {
    return (
      <DOCOnlineError errorMessage={t("This DOC Online is not available.")} />
    );
  }

  return (
    <div className="doconline-container">
      <DOCOnlineProvider>
        <div className="navbar-container">
          <DocOnlineNavbar candidacyCompany={candidacyCompany} />
        </div>
        <div className="body-container">
          <DOCOnlineBody
            token={props.match.params.token}
            companyId={companyId}
            isLoading={isLoading}
          />
        </div>
        <div className="footer-container">
          <DocOnlineFooter 
            candidacyCompany={candidacyCompany}
            privacyPolicy = {privacyPolicy}
          />
        </div>
      </DOCOnlineProvider>
    </div>
  );
};

export default DOCOnlinePage;
